import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'address'
})
export class AddressPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (args === 'extension') {
      return ((value.country ? value.country + ' - ' : '') +
        (value.city ? value.city + ' ' : ''));
    }
    return ((value.country ? value.country + ' ' : '') +
      (value.postalCode ? value.postalCode + ' - ' : '') +
      (value.city ? value.city + ' ' : '') +
      (value.line ? value.line : ''));
  }

}
